import { h } from 'preact';
import { useState } from 'preact/hooks';

export const tabs = function({ children }) {
  const [sel, setSel] = useState(0);
  const names = children.map((x, i) => x.props.name || ('Tab' + (i + 1)));
  if (sel < 0) setSel(0);
  return h('div', { class: 'pre-nav-list' },
    h('div', null, names.map((n, i) =>
      h(tab, { key: i, i, name: n, sel, setSel }))),
    children[sel],
  );
};

function tab({ i, name, sel, setSel }) {
  const p = i === sel;
  // console.log(name, i, sel);
  const style = {
    border: '2px ' + (p ? 'inset' : 'outset') + ' black',
    borderRadius: '1px 0 0 1px',
    background: p ? 'gray' : null,
  };
  const onClick = p ? null : e => setSel(i);
  return h('span', { style, onClick },
    name,
  );
}
